module.exports = __webpack_public_path__ + "media/images/ui__checkArrow--dark-c8d7e344ecbfde406b16e6d75c8ec6e1.png";